import { render, staticRenderFns } from "./ContatoParceiros.vue?vue&type=template&id=1469eafe&"
import script from "./ContatoParceiros.vue?vue&type=script&lang=js&"
export * from "./ContatoParceiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports